import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";



const HbsBanner = () => {
    const { clientAssetsLink } = useClientConfig();
    const getAsset = (file: string) =>
        clientAssetsLink + "/" + file;


    return (
        <section id="hbs-banner" className="hbs-banner">
            <div className="container">
                <div className="flex-box">
                    <div className="left-box">
                        <div className="content">
                            <h1>Careers at Hilton Brown Swimming</h1>
                            <p>
                                Love the water? Love working with people? Join a team thats
                                passionate about teaching #lessonsforlife and helping swimmers of
                                all ages grow in confidence, skill and safety.
                            </p>
                        </div>
                    </div>
                    <div className="right-box">
                        <div className="image desktop">
                            <img
                                // src={`${clientAssetsLink}/careers-icon.svg`}
                                src={getAsset("careers-icon.svg")}
                                className="img-fluid wp-post-image"
                                alt="Careers"
                                decoding="async"
                                loading="lazy"
                            />{" "}
                        </div>
                        <div className="image mobile" >
                            <img
                                // src={`${clientAssetsLink}/career-mobile-icon.svg`}
                                src={getAsset("career-mobile-icon.svg")}
                                alt=""
                                className="img-fluid"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HbsBanner;